import React from 'react';
import {
  Card,
  CardContent,
  CardMedia,
  Carousel,
  CarouselItem,
} from '@americanexpress/dls-react';
import { useSelector } from 'react-redux';
import {
  useOneCmsLocalePartners,
  useOneCmsLocaleOverviewDisclaimer,
  useOneCmsLocaleOverviewBody,
  useCommonContent,
} from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { getOneCmsLoungeFinderImagesBaseUrl } from '@/selectors/oneCmsSelectors';
import { useRouteParams } from '@/context/routeParamsContext';
import { cn, filterCenturionProvidersForDisplay } from '@/helpers/utils';
import styles from './LandingPartnerLogosSection.module.scss';

const LandingPartnerLogosSection = () => {
  const { product } = useRouteParams();
  let partners = useOneCmsLocalePartners();
  const baseOneCmsImgUrl = useSelector(getOneCmsLoungeFinderImagesBaseUrl);
  const disclaimer = useOneCmsLocaleOverviewDisclaimer();
  const overviewBody = useOneCmsLocaleOverviewBody();
  const content = useCommonContent();
  const isGlobalLoungeCollectionPartner = partners.some(
    (item) =>
      item.partner_name === 'The American Express Global Lounge Collection®'
  );
  if (!isGlobalLoungeCollectionPartner) {
    const globalLoungeCollectionObj = {
      logo: 'amex-international-logo.png',
      link_URL: '',
      link_label: '',
      partner_name: 'The American Express Global Lounge Collection®',
    };
    partners = [globalLoungeCollectionObj, ...partners];
  }
  // Filter partners so only 1 Centurion provider shows (each country Centurion Provider is a separate array entry)
  partners = filterCenturionProvidersForDisplay(partners);

  return (
    <>
      <h2 className="tw-heading-md-regular tw-mb-6 tw-mt-10 tw-text-gray-900">
        {content?.partners?.header || 'Programs & Partners'}
      </h2>
      <Carousel
        id="partners-carousel"
        data-testid="partners-carousel"
        labelOverrides={{
          'aria-label': 'Carousel',
        }}
        isSlideFullWidth={false}
      >
        {partners.map(
          (
            {
              logo: partnerLogo,
              link_URL: linkUrl,
              link_label: linklabel,
              partner_name: partnerName,
            },
            idx
          ) => {
            return (
              <CarouselItem
                id={partnerName}
                key={partnerName}
                className={styles.carouselItem}
              >
                <Card
                  key={partnerName}
                  className={`tw-h-97 tw-w-full tw-rounded-2xl tw-border tw-border-gray-300 first-child_tw-flex first-child_tw-items-center first-child_tw-justify-center first-child_tw-shadow-none ${partnerName === 'The American Express Global Lounge Collection®' ? 'tw-border-none first-child_tw-bg-blue-deep-700' : ''}`}
                >
                  {linklabel ? (
                    <>
                      <div>
                        <CardMedia>
                          <img
                            src={`${baseOneCmsImgUrl}${partnerLogo}`}
                            alt={partnerName}
                            className={styles.partnerLogoImg}
                          />
                        </CardMedia>
                      </div>
                      {idx !== 1 && (
                        <div className={styles.partnerLinkContainer}>
                          {linkUrl ? (
                            <a
                              href={linkUrl}
                              className={styles.partnerLink}
                              rel="noopener noreferrer"
                              target="_blank"
                            >
                              <p>{linklabel}</p>
                            </a>
                          ) : (
                            <p>{linklabel}</p>
                          )}
                        </div>
                      )}
                    </>
                  ) : partnerName ===
                      'The American Express Global Lounge Collection®' &&
                    product !== 'delta-reserve' ? (
                    <div className="relative tw-overflow-auto tw-bg-blue-deep-700">
                      <CardMedia className="tw-flex tw-justify-center tw-pb-4">
                        <img
                          src={`${baseOneCmsImgUrl}amex-international-logo.png`}
                          alt={partnerName}
                          className={styles.partnerLogoImg}
                        />
                      </CardMedia>
                      <CardContent alignment="center">
                        <p
                          className={cn(
                            styles.overviewBody,
                            'tw-mb-2 tw-px-2 tw-text-gray-100'
                          )}
                        >
                          {overviewBody}
                        </p>
                        <p
                          className={cn(
                            styles.overviewDisclaimer,
                            'tw-text-sm tw-text-gray-200'
                          )}
                        >
                          {disclaimer}
                        </p>
                      </CardContent>
                      <div
                        style={{
                          backgroundImage: `linear-gradient(180deg, #00175a 0%, rgba(0, 23, 90, 0) 100%), url(${baseOneCmsImgUrl}amex-logo-accent-img.png)`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          width: '100%',
                          aspectRatio: '24 / 5',
                          position: 'absolute',
                          bottom: '0',
                          marginLeft: '-1rem',
                          borderRadius: '1rem',
                        }}
                      />
                    </div>
                  ) : (
                    <div>
                      <CardMedia>
                        <img
                          src={`${baseOneCmsImgUrl}${partnerLogo}`}
                          alt={partnerName}
                          className={styles.partnerLogoImg}
                        />
                      </CardMedia>
                    </div>
                  )}
                </Card>
              </CarouselItem>
            );
          }
        )}
      </Carousel>
    </>
  );
};
export default LandingPartnerLogosSection;
